import { render, staticRenderFns } from "./DiscountBlock.vue?vue&type=template&id=faa3dbaa&"
import script from "./DiscountBlock.vue?vue&type=script&lang=ts&"
export * from "./DiscountBlock.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports